import { render, staticRenderFns } from "./Storeabout.vue?vue&type=template&id=ce97ff58&scoped=true&"
import script from "./Storeabout.vue?vue&type=script&lang=js&"
export * from "./Storeabout.vue?vue&type=script&lang=js&"
import style0 from "./Storeabout.vue?vue&type=style&index=0&id=ce97ff58&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce97ff58",
  null
  
)

export default component.exports